import React from 'react'

export default function Container({ children, fluid, maxWidth }) {
    return (
        <div style={{
            maxWidth: fluid ? '100%' : maxWidth ? maxWidth : 1440,
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        }}>
            {children}
        </div>
    )
}
